import React, { PureComponent } from 'react';
import './DittoContainer.scss';

class DittoContainer extends PureComponent {
  render() {
    const {
      dittoVisible,
      dataLocale: { DITTO_CONTAINER },
    } = this.props;
    return (
      <div
        aria-label={DITTO_CONTAINER}
        className={`image-container dittoContainer ${!dittoVisible ? 'hidden' : ''}`}
      >
        <div className="col-lg-12 col-md-12 col-sm-12 dittoWrapper no-padding">
          <div className="dittoContainer_ditto" id="ditto" />
        </div>
      </div>
    );
  }
}

export default DittoContainer;
